import type {
  FilterControlOperator,
  FilterControlOperatorOptional,
} from 'lib-analytics-types';

export const isOptionalOperator = (
  operator?: FilterControlOperator,
): operator is 'is_empty' | 'is_not_empty' =>
  typeof operator !== 'undefined' &&
  (
    ['is_empty', 'is_not_empty'] satisfies FilterControlOperatorOptional[]
  ).includes(operator as FilterControlOperatorOptional);
